<template>
  <a-card :bordered="false">
    <a-spin :spinning="confirmLoading">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16">
            <a-col :xl="6" :lg="8" :md="8" :sm="24">
              <a-form-item label="考勤小组">
                <a-select
                  allowClear
                  @select="selectChange"
                  showSearch
                  placeholder="请选择"
                  :filterOption="filterOption"
                  v-model="queryParam.groupId"
                  :options="attendGroupList">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="8" :md="8" :sm="24">
              <a-form-item label="时间">
                <a-month-picker
                  style="width: 100%"
                  @change="onDateChange"
                  :allowClear="false"
                  :value="defaultDate"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="8" :md="8" :sm="24">
              <a-form-item label="工人类别">
                <a-select
                  allowClear
                  @select="selectWorkerChange"
                  showSearch
                  placeholder="请选择"
                  :filterOption="filterOption"
                  v-model="queryParam.typeId"
                  :options="workerList">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="6" :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button @click="getAttendanceAndTheadRes()" type="primary">查询</a-button>
                <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
                <a-button type="danger" style="margin-left: 8px" @click="del()" v-action="'attend:del'">删除</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="handleExportExcel()" icon="export" v-action="'attend:editDaily:export'">导出Excel</a-button>
      </div>
      <a-alert :message="'总工日 ：'+ workDays + ' 天'" type="success" />
      <div v-if="attendanceData.length > 0">
        <div class="attendanceContent">
          <div class="scrollBox">
            <table>
              <thead>
                <th>
                  <span>姓名</span>
                </th>
                <th v-for="(dateItem,index) in dateThead" :key="index">
                  <span>{{ dateItem }}</span>
                </th>
                <th>
                  <span>合计</span>
                </th>
              </thead>
              <tbody>
                <tr v-for="personItem in attendanceData" :key="personItem.workerId">
                  <td v-if="personItem.workHourList">
                    <span>{{ personItem.name }}</span>
                  </td>
                  <td v-for="hourItem in personItem.workHourList" :key="hourItem.date">
                    <span v-if="hourItem.workHour === -1">未填写</span>
                    <a-badge :count="hourItem.workHour + ' h'" :numberStyle="{backgroundColor: '#52c41a','border-radius':'0'} " :showZero="true" v-else/>
                  </td>
                  <td>
                    <a-badge :count="personItem.totalWorkHour + ' h'" :numberStyle="{backgroundColor: '#52c41a','border-radius':'0'} " :showZero="true"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <a-pagination
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageOptions.pageSizeOptions"
          :total="pageOptions.total"
          :pageSize="pageOptions.pageSize"
          v-model="pageOptions.current"
          @showSizeChange="onShowSizeChange"
          @change="onPageChange"
          style="float: right;margin-top: 24px"/>
      </div>
      <empty-image v-else></empty-image>
    </a-spin>
    <del-daily-record ref="delDailyRecord" @ok="getAttendanceAndTheadRes"></del-daily-record>
  </a-card>
</template>

<script>
import moment from 'moment'
import { attendGroupList } from '@api/common/AttendGroup'
import { getWorkerTypeList } from '@api/common/SxWorkerType'
import { fetchList, exportExcel } from '@api/attend/attendDaily'
import EmptyImage from './component/EmptyImage'
import DelDailyRecord from './DelDailyRecord'
export default {
  name: 'ShowDaily',
  components: {
    EmptyImage,
    DelDailyRecord
  },
  data () {
    return {
      attendGroupList: [],
      workerList: [],
      workDays: 0,
      confirmLoading: false,
      queryParam: {
        groupId: '',
        startDate: '',
        endDate: '',
        current: 1,
        size: 10,
        typeId: undefined
      },
      dateThead: [],
      attendanceData: [],
      pageOptions: {
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 500
      },
      defaultDate: moment().endOf('month'),
      dateRange: [moment().startOf('month'), moment().endOf('month')] // 时间范围
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    init () {
      attendGroupList().then(res => {
        this.attendGroupList = res.data
        // 修改原因：不同权限对应的下拉选择框的第一个数据不一样，所以此处动态取值
        this.queryParam.groupId = res.data[0].value
        this.getAttendanceAndTheadRes()
        this.getWorkerTypeList(res.data[0].value)
      })
    },
    /**
     * 日期处理
     * */
    onDateChange (date) {
      this.defaultDate = date
      // 这里是重点，需要新复制一份这个日期，不然日期是唯一的，就是你的开始和结束日期会是同一天
      const newDate = date.clone()
      // 给dateRange 变量赋值 这个月的开始和结束，用于传递给后端使用between查询
      this.dateRange[0] = date.startOf('month')
      this.dateRange[1] = newDate.endOf('month')
    },
    /*
   * 从后台获取考勤数据和表头数据
   * */
    getAttendanceAndTheadRes () {
      this.workDays = 0
      this.confirmLoading = true
      // 清空数组
      this.attendanceData = []
      // 设置分页参数
      this.queryParam.current = this.pageOptions.current
      this.queryParam.size = this.pageOptions.pageSize
      this.queryParam.startDate = this.dateRange[0].format('YYYY-MM-DD')
      this.queryParam.endDate = this.dateRange[1].format('YYYY-MM-DD')
      fetchList(this.queryParam).then((res) => {
        this.confirmLoading = false
        // 从分页结果中取数据
        const pageInfo = res.data.workerList
        if (pageInfo) {
          this.pageOptions.total = Number.parseInt(pageInfo.total)
          this.pageOptions.current = Number.parseInt(pageInfo.current)
          this.workDays = pageInfo.workDays
          this.getAttendanceData(pageInfo.records)
          this.getTheadData(res.data.dateThead)
        }
      }).catch(err => {
        this.confirmLoading = false
        this.$message.error(err.msg)
      })
    },
    del () {
      this.$refs.delDailyRecord.init('', 'add')
    },
    getTheadData (theadData) {
      let strArray = []
      this.dateThead = []
      theadData.forEach(item => {
        strArray = item.split('-')
        item = strArray[1] + '-' + strArray[2]
        this.dateThead.push(item)
      })
    },
    getAttendanceData (attendanceData) {
      this.attendanceData = []
      if (attendanceData) {
        this.attendanceData = [...attendanceData]
      }
    },
    onPageChange (pageNumber) {
      this.pageOptions.current = pageNumber
      this.getAttendanceAndTheadRes()
    },
    onShowSizeChange (current, pageSize) {
      this.pageOptions.current = 1
      this.pageOptions.pageSize = pageSize
      this.getAttendanceAndTheadRes()
    },
    handleExportExcel () {
      this.confirmLoading = true
      exportExcel(this.queryParam).then((res) => {
        this.confirmLoading = false
        const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '考勤导出.xls'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
        this.confirmLoading = false
      })
    },
    // 选中考勤小组时触发
    selectChange (e) {
      if (e != null) {
        this.queryParam.groupId = e
      }
      // 选定考勤小组时，前一次选中的工人类别可能有缓存，要先置空
      this.queryParam.typeId = null
      // 过滤工人类别
      this.getWorkerTypeList(e)
      this.getAttendanceAndTheadRes()
    },
    // 通过考勤小组获取工人类别
    getWorkerTypeList (e) {
      this.workerList = []
      getWorkerTypeList(e).then(res => {
        this.workerList = res.data
      })
    },
    selectWorkerChange (e) {
      if (e != null) {
        this.queryParam.typeId = e
      }
      this.getAttendanceAndTheadRes()
    }
  }
}
</script>

<style lang="less" scoped>
  .attendanceContent{
    position: relative;
  }
  .scrollBox{
    overflow: hidden;
    overflow-x: auto;
  }
  table{
    width: 100%;
    border-radius: 4px 4px 0 0;
    border-collapse: collapse;
    background-color: #fff;
    text-align: center;
    white-space: nowrap;
    thead{
      border-bottom: 1px solid #ddd;
    }
    tr+ tr{
      border-top: 1px solid #ddd;
    }
    thead th:first-child, thead th:last-child, tr td:first-child, tr td:last-child {
      width: 120px;
      background: #fff;
      text-align: center;
      position: absolute;
      z-index: 11;
    }
    thead{
      th{
        padding: 16px;
        font-weight: normal;
        &:first-child{
          left: 0;
          box-shadow: 4px 4px 6px -4px rgba(0, 0, 0, 0.15);
        }
        &:last-child{
          right: 0;
          box-shadow: -4px 4px 6px -4px rgba(0, 0, 0, 0.15);
        }
        &:nth-child(2){
          padding-left:150px ;
        }
        &:nth-last-child(2){
          padding-right:150px ;
        }
      }
    }
    tr{
      td{
        padding: 16px;
        line-height: 2;
        &:first-child{
          left: 0;
          box-shadow: 4px 4px 6px -4px rgba(0, 0, 0, 0.15);
        }
        &:last-child{
          right: 0;
          box-shadow: -4px 4px 6px -4px rgba(0, 0, 0, 0.15);
        }
        &:nth-child(2){
          padding-left:150px ;
        }
        &:nth-last-child(2){
          padding-right:150px ;
        }
      }
    }
  }
</style>
